<template>
  <review-status
    :state="decision"
    :message="message"
  />
</template>

<script>
import ReviewStatus from "../../../../../../../js/components/global/ReviewStatus.vue";

export default {
  components: {ReviewStatus},
  props: {
    keywordReview: {
      type: Object,
      default: null,
    },
    pendingMessage: {
      type: String,
      default: 'Pending review, this may take a few moments',
    }
  },
  computed: {
    decision() {
        return this.keywordReview?.decision || 'pending';
    },
    message() {
      const description = this.keywordReview?.description || '';

      switch (this.decision) {
        case 'good':
          return description;
        case 'bad':
          return `
            Why this might not be a good keyword for you:
            <br><br>
            ${description.charAt(0).toUpperCase() + description.slice(1)}
            <br><br>
            Alternative keywords:<br>
            ${this.keywordReview.suggestions.map(suggestion => suggestion.keyword).join(', ')}
          `;
        default:
          return this.pendingMessage;
      }
    }
  }
}
</script>
